import { Box } from "@mui/material";
import { useAuth } from "contexts/AuthContext";
import usePage from "hooks/usePage";
import SideNav from "./layout/SideNav";
import RunListSidebar from "./run/RunListSidebar";

export default function AppLayout({ children }) {
  const { currentUser } = useAuth();
  const isLoggedIn = !!currentUser;
  const { isCustomerListPage, isSharePage, isRiskPage } = usePage();

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        width: "100vw",
      }}
    >
      {(isLoggedIn && !isCustomerListPage) || isSharePage ? (
        <>
          <SideNav />
          {!isRiskPage && <RunListSidebar />}
        </>
      ) : null}
      <Box sx={{ flexGrow: 1, position: "relative" }}>{children}</Box>
    </Box>
  );
}
